import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { HistoryLog } from '@helpers/types/models';
import {
	AlarisComplexTableComponent, AlarisDialogService,
	AlarisTableStateService, RowActionSimple,
	TABLE_STATE_SERVICE_INJECTOR
} from '@campaign-portal/components-library';
import { TableSettingsService } from '@helpers/api/table-settings.service';
import { TableTypes } from '@campaign-portal/namespace/entities/table-settings/specs';
import { Paging } from '@campaign-portal/namespace/common/rpc.params';
import { HistoryLogsService } from './history-logs.service';
import { HistoryLogsFieldsService } from './history-logs-fields.service';
import { UserService } from '../../auth/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HistoryLogsChangesComponent } from './history-logs-changes/history-logs-changes.component';
import { UsersService } from '../users/users.service';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'app-history-logs',
	templateUrl: './history-logs.component.html',
	styleUrls: [
		'../../../../node_modules/@campaign-portal/components-library/src/assets/templates/table-complex/complex-table.component.scss',
		'./history-logs.component.scss'
	],
	providers: [
		AlarisTableStateService,
		{ provide: TABLE_STATE_SERVICE_INJECTOR, useExisting: AlarisTableStateService }
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class HistoryLogsComponent extends AlarisComplexTableComponent<HistoryLog> implements OnInit {
	override readonly pageSizeOptions = [25, 50, 100, 200];
	override readonly paging: Paging = {
		Skip: this.activePage,
		Take: this.pageSize
	};

	override readonly rowActions: RowActionSimple<any>[] = [
		{
			icon: 'icon-info',
			label: 'actions.view',
			action: this.viewResults.bind(this),
			highlight: true,
			separator: true,
			disabled: (): boolean => {
				return !this.user.allowed(['history_logs.read']);
			}
		}
	];

	constructor(
		private readonly dialog: AlarisDialogService,
		public readonly user: UserService,
		dataService: HistoryLogsService,
		protected readonly service: HistoryLogsService,
		public override readonly fieldsService: HistoryLogsFieldsService,
		tableSettingsService: TableSettingsService,
		readonly users: UsersService
	) {
		super(
			dataService,
			fieldsService,
			tableSettingsService,
			TableTypes.INTERNAL
		);
		this.state.filters()
			.set('id', { enabled: true })
			.set('actionId', { enabled: true })
			.set('tableName', { enabled: true })
			.set('actionType', { enabled: true })
			.set('recordCount', { enabled: true })
			.set('tableName', { enabled: true })
			.set('actionTimeFrom', { enabled: true })
			.set('actionTimeTo', { enabled: true })
			.set('user', { enabled: true })
	}

	override ngOnInit(): void {
		super.ngOnInit();
		this.users
			.load()
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(() => {
				this.setRefBooksInFields({
					UserID: {
						list$: new BehaviorSubject<{ name: string; value: number }[]>(
							this.users.list.map((user) => {
								return {
									name: user.Login,
									value: user.ID
								};
							})
						)
					}
				});
			});
	}

	viewResults(log: HistoryLog): void {
		this.service.loadDetails(log).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res =>{
			if (res) {
				this.dialog.open<boolean>(HistoryLogsChangesComponent, { autoFocus: false, data: res?.Data });
			}
		});
	}
}
